<!-- Loading Skeleton -->
<div class="categories-skeleton" *ngIf="isCategoriesLoading || isOrderDetailsLoading">
  <div class="container">
    <div class="skeleton-header">
      <div class="skeleton-title"></div>
      <div class="skeleton-cart-icon"></div>
    </div>

    <div class="skeleton-search">
      <div class="skeleton-search-bar"></div>
    </div>

    <div class="skeleton-section-title"></div>

    <div class="skeleton-categories">
      <div class="skeleton-category-grid">
        <div class="skeleton-category-item" *ngFor="let item of skeletonItems">
          <div class="skeleton-category-image"></div>
          <div class="skeleton-category-name"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Main Content -->
<div class="categories-container" *ngIf="!isCategoriesLoading && !isOrderDetailsLoading">
  <div class="container">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-content">
        <div class="header-info">
          <div class="order-badge">
            <i class="fas fa-receipt"></i>
            <span>Create Order</span>
          </div>
          <h2 class="order-title">
            Create order for
            <span class="customer-name">{{ orderDetails?.barcode_details?.name }}</span>
          </h2>
        </div>
        <div class="cart-section">
          <button class="cart-btn" (click)="cart(content2)">
            <div class="cart-icon-wrapper">
              <i class="fas fa-shopping-cart"></i>
            </div>
            <span class="cart-text">Cart</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Search Section -->
    <div class="search-section">
      <div class="search-card">
        <div class="search-header">
          <i class="fas fa-search search-icon"></i>
          <h3>Search Products</h3>
        </div>
        <div class="search-wrapper">
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (input)="onSearch($event)"
            placeholder="Search for products, brands and categories"
            class="search-input" />
          <div class="search-actions">
            <button class="search-btn">
              <i class="fas fa-search"></i>
            </button>
            <button class="clear-btn" *ngIf="searchTerm" (click)="closeDropdown(); searchTerm = ''">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <!-- Search Dropdown -->
        <div class="search-dropdown" *ngIf="showDropdown" [@slideDown]>
          <!-- Loading State -->
          <div class="loading-state" *ngIf="isLoading">
            <div class="search-spinner"></div>
            <span>Searching...</span>
          </div>

          <!-- Results -->
          <div class="search-results" *ngIf="!isLoading && searchResults.length > 0">
            <div class="search-item"
                 *ngFor="let item of searchResults"
                 (click)="selectItem(item)"
                 [@fadeInUp]>
              <div class="search-item-details">
                <div class="search-item-name">{{item.name}}</div>
                <div class="search-item-meta">
                  <span class="search-item-price">{{item.selling_price | currency: '₦'}}</span>
                  <span class="search-item-quantity">({{item.quantity}} in stock)</span>
                </div>
                <div class="search-item-category" *ngIf="item.category">
                  <i class="fas fa-tag"></i>
                  in {{item.category.name}}
                </div>
              </div>
              <div class="search-item-arrow">
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>
          </div>

          <!-- No Results -->
          <div class="no-results" *ngIf="!isLoading && searchResults.length === 0 && searchTerm">
            <div class="no-results-icon">
              <i class="fas fa-search"></i>
            </div>
            <div class="no-results-text">
              <h4>No results found</h4>
              <p>No results found for "<strong>{{searchTerm}}</strong>"</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Categories Section -->
    <div class="categories-section">
      <div class="section-header">
        <div class="section-info">
          <h3>Browse Categories</h3>
          <span class="categories-count">{{categories.length}} categories available</span>
        </div>
      </div>

      <div class="categories-grid" [@staggerAnimation]="categories.length">
        <div class="category-card"
             *ngFor="let category of categories; let i = index; trackBy: trackByCategory"
             [@fadeInUp]>
          <a [routerLink]="['/orders/'+id+'/categories/'+category.id+'/inventories']"
             class="category-link">
            <div class="category-image-wrapper" [ngClass]="getRandomColorClass(i)">
              <img [src]="category.image"
                   [alt]="category.name"
                   class="category-image"
                   (error)="onImageError($event)">
              <div class="category-overlay">
                <i class="fas fa-arrow-right"></i>
              </div>
            </div>
            <div class="category-info">
              <h4 class="category-name">{{ category.name }}</h4>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Cart Modal -->
<ng-template #content2 let-modal>
  <div class="custom-modal cart-modal">
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-shopping-cart"></i>
        <h3>Your Cart</h3>
      </div>
      <button type="button" class="modal-close-btn" (click)="modal.close('Cross click')">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <app-cart [orderId]="id"></app-cart>
    </div>
  </div>
</ng-template>
